import { Component, ElementRef, DOCUMENT, inject, output, signal, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { NgOptimizedImage } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { IndustriesService } from '../../services/industries.service';
import { TrucksService } from '../../services/trucks.service';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';

type Tab = 'modelos' | 'industrias';

@Component({
  selector: 'app-megamenu-camiones',
  standalone: true,
  imports: [RouterLink, NgOptimizedImage],
  templateUrl: './megamenu-camiones.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './megamenu-camiones.scss',
})
export class MegamenuCamionesComponent {
  private router = inject(Router);
  private document = inject(DOCUMENT);
  private industriesService = inject(IndustriesService);
  private trucksService = inject(TrucksService);
  linkClick = output<void>();
  @ViewChild('inner') private innerEl!: ElementRef<HTMLElement>;

  activeTab = signal<Tab>('modelos');

  readonly modelos = toSignal(
    this.trucksService.getTrucks().pipe(
      map((trucks) => trucks.filter((t) => t.showMegaMenu)),
      catchError(() => of([])),
    ),
    { initialValue: [] },
  );

  readonly industrias = toSignal(
    this.industriesService.getIndustries().pipe(catchError(() => of([]))),
    { initialValue: [] },
  );

  setTab(tab: Tab) {
    this.activeTab.set(tab);
  }

  resetScroll() {
    if (this.innerEl?.nativeElement) {
      this.innerEl.nativeElement.scrollTop = 0;
    }
  }

  navigateTo(url: string): void {
    this.router.navigate([url]);
    this.linkClick.emit();
  }

  navigateToExternal(url: string): void {
    this.document.defaultView?.open(url, '_blank', 'noopener');
    this.linkClick.emit();
  }

  onLink() {
    this.linkClick.emit();
  }
}
